import { render } from "./multipleBillingModel.vue?vue&type=template&id=3ee32496"
import script from "./multipleBillingModel.vue?vue&type=script&lang=js"
export * from "./multipleBillingModel.vue?vue&type=script&lang=js"

import "./multipleBillingModel.vue?vue&type=style&index=0&id=3ee32496&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__